<template>
	<v-card>
		<v-card-title>
			<translate>{{ title }}</translate>
		</v-card-title>
		<v-card-text>
			<v-item-group>
				<v-row>
					<v-col>
						<div
							v-for="item in items"
							:key="item.value"
						>
							<v-checkbox
								v-model="selectedItem"
								color="primary"
								:label="item.label"
								:value="item.value"
								hide-details
							/>
						</div>
					</v-col>
				</v-row>
			</v-item-group>
		</v-card-text>
		<v-card-actions>
			<v-spacer />
			<v-btn
				variant="text"
				color="primary"
				@click="postItem"
			>
				<translate>Save</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	debounce,
} from 'lodash';
import {
	inform,
} from 'laravel-front-library';

export default {
	name: 'SingleSelectCheckBoxCard',
	props: {
		title: {
			type: String,
			required: true,
		},
		getEndPoint: {
			type: String,
			required: true,
		},
		postEndPoint: {
			type: String,
			required: true,
		},
		postSuccess: {
			type: String,
			default: 'Submission succesfull'
		},
		refreshOnSubmit: {
			type: Boolean,
			default: true
		},
		postName: {
			type: String,
			default: 'item',
		},
		additionalSubmit: {
			type: Object,
			default: () => ({
			}),
		},
		additionalGet: {
			type: Object,
			default: () => ({
			}),
		},
	},

	data () {
		return {
			items: [],
			selectedItem: null,
		};
	},

	mounted () {
		this.getItems();
	},

	methods: {
		/**
		 * Get all items for the checkbox list
		 *
		 * @returns {void}
		 */
		getItems () {
			axios.get(this.getEndPoint, {
				params: this.additionalGet
			}).then(({
				data,
			}) => {
				this.items = data.items;
				this.selectedItem = data.selected;
			}).catch((error) => {
				window.captureException(error);

			});
		},

		/**
		 * Submit item value
		 *
		 * @returns {void}
		 */
		postItem () {
			const data = new FormData();

			data.set(this.postName, this.selectedItem);
			for(const [key, value, ] of Object.entries(this.additionalSubmit)) {
				data.set(key, value);
			}
			axios.post(this.postEndPoint,
				data).then(() => {
				inform(this.$gettext(this.postSuccess));
				if (this.refreshOnSubmit) {
					debounce(() => {
						window.location.reload();
					}, 500)();
				}
			}).catch((error) => {
				window.captureException(error);
			});
		}
	},
};
</script>
